// import { Uid } from "./Uid";
import { User, Uid } from "./User";

//users/userblocks
export class UserBlock {
  static COL = 'userblocks';
  id: string = Uid.get();
  created = new Date();

  constructor(public blockedUser: User, public byUserId: string) {
  }
}
